(function() {
  function updateMainPrice(label) {
    var priceEl = label.querySelector('.shopify_subscriptions_in_widget_price');
    if (!priceEl) return;
    var priceText = priceEl.textContent.trim().replace(/\s*EUR$/, '');
    var targets = document.querySelectorAll('.product-details product-price .price');
    targets.forEach(function(el) {
      el.innerHTML = priceText + '<span style="font-size:0.6em;opacity:0.55;font-weight:400;"> /Monat</span>';
    });
  }

  function initSubPills() {
    var labels = document.querySelectorAll('.shopify_subscriptions_app_block_label');
    if (!labels.length) return false;

    labels.forEach(function(label) {
      var nameEl = label.querySelector('.shopify_subscriptions_purchase_option_wrapper label');
      if (nameEl) {
        var t = nameEl.textContent.trim();
        var s = t.replace(/^.*?-\s*/, '').replace('1 Jahr', '12 Monate');
        nameEl.textContent = s;
      }
      label.addEventListener('click', function() {
        var radio = label.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateMainPrice(label);
      });
    });

    /* Pre-select first plan */
    var firstLabel = labels[0];
    var firstRadio = firstLabel.querySelector('input[type="radio"]');
    if (firstRadio && !document.querySelector('.shopify_subscriptions_app_block_label input[type="radio"]:checked')) {
      firstRadio.checked = true;
      firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Set price immediately + watch for resets */
    updateMainPrice(firstLabel);
    setTimeout(function() { updateMainPrice(firstLabel); }, 200);
    setTimeout(function() { updateMainPrice(firstLabel); }, 500);
    setTimeout(function() { updateMainPrice(firstLabel); }, 1000);

    /* Observe price element for resets by theme components */
    var priceContainer = document.querySelector('.product-details product-price');
    if (priceContainer) {
      var selectedLabel = function() {
        var checked = document.querySelector('.shopify_subscriptions_app_block_label input[type="radio"]:checked');
        return checked ? checked.closest('.shopify_subscriptions_app_block_label') : firstLabel;
      };
      new MutationObserver(function() {
        var mainPrice = priceContainer.querySelector('.price');
        if (mainPrice && mainPrice.textContent.indexOf('0,00') !== -1) {
          updateMainPrice(selectedLabel());
        }
      }).observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }

    return true;
  }

  if (!initSubPills()) {
    var obs = new MutationObserver(function() {
      if (document.querySelector('.shopify_subscriptions_app_block_label')) {
        obs.disconnect();
        setTimeout(initSubPills, 100);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();
